import React from 'react';

import { ReactComponent as Favorite } from '../icons/material/favorite_black_24dp.svg';
import { ReactComponent as FavoriteBorder } from '../icons/material/favorite_border_black_24dp.svg';

export default class WishListButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOnWishList: this.props.isOnWishList,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isOnWishList !== this.state.isOnWishList) {
            this.setState({ isOnWishList: this.props.isOnWishList });
        }
    }

    addOrRemoveProductFromWishList = (e, id) => {
        this.props.updateWishList(e, id);
        if (this.state.isOnWishList) this.setState({ isOnWishList: false });
        else this.setState({ isOnWishList: true });
        return false;
    };

    render() {
        return (
            <div
                className={this.props.className + ' wishList'}
                onClick={(e) => this.addOrRemoveProductFromWishList(e, this.props.id)}
                role="button"
                aria-label={'Bæta á óskalista'}
            >
                {this.state.isOnWishList ? <Favorite /> : <FavoriteBorder />}
            </div>
        );
    }
}
